import React, {useEffect, useState} from 'react';
import CustomSelect from "../form/CustomSelect";
import { GetStates } from "../../api/offices/GetStates";
import {useTranslation} from "react-i18next";

const RoleSelect = (props) => {

    const { t } = useTranslation();

    const [availableStates, setAvailableStates] = useState([]);

    useEffect(() => {
        const setStates = async function (){
            try {
                const data = await GetStates();
                setAvailableStates(data);
            } catch (err){
                console.log("Error fetching user roles: " + err);
            }
        }
        setStates();
    }, []);

    return (
        <CustomSelect
            placeholder={<div>{t("Select province")}</div>}
            options={availableStates}
            onChange={props.onChange}
            value={availableStates.find(option => option.value.toLowerCase() === props.value.toLowerCase())}
        />
    );
};

export default RoleSelect;
